import React from 'react';
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
  To,
  useNavigate,
} from 'react-router-dom';

interface LinkProps extends RouterLinkProps {
  to: To;
  children: React.ReactNode;
}

const Link: React.FC<LinkProps> = ({ to, children, ...props }) => {
  const navigate = useNavigate();

  const isMarketing = to === '/'; // todo(jgan): define marketing routes as constants

  const handleClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    if (isMarketing) {
      // Perform a full-page reload for marketing (external) routes
      window.location.href = to;
    } else {
      // Prevent default behavior and navigate SPA-style for app (internal) routes
      event.preventDefault();
      navigate(to);
    }
  };

  return isMarketing ? (
    <a href={to} {...props}>
      {children}
    </a>
  ) : (
    <RouterLink to={to} onClick={handleClick} {...props}>
      {children}
    </RouterLink>
  );
};

export default Link;
